import {MenuItem, styled} from '@mui/material';

export const StyledMenuItem = styled(MenuItem)`
	color: ${({theme}) => theme.palette.text.primary};
	font-weight: 600;
`;
